import React from 'react'
import '../../RolesPermissionsDashboard/RolesPermissionsDashboard.css';

const UsersRolesDashboard = () => {
  return (
    <div>UsersRolesDashboard</div>
  )
}

export default UsersRolesDashboard